/* eslint-disable @typescript-eslint/no-explicit-any */ import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@cinch-labs/design-system";
const FindACarTextField = ({ input , onBlur , label , inputRef , onFocus , onChange , ...rest })=>{
    /*#__PURE__*/ return _jsx(TextField, {
        ...rest,
        label: label,
        id: rest.id,
        name: input.name,
        type: input.type ? input.type : "text",
        value: input.value,
        onChange: (e)=>{
            input.onChange(e);
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        },
        onBlur: (e)=>{
            input.onBlur(e);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        },
        onFocus: (e)=>{
            input.onFocus(e);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        },
        ref: inputRef
    });
};
export default FindACarTextField;
